import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'oap-info-required-fields',
  templateUrl: './info-required-fields.component.html',
  styleUrls: ['./info-required-fields.component.scss']
})
export class InfoRequiredFieldsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
